import * as types from './types'

export default {
  [types.REQUESTS_SEARCH_RESULT]: state => state.requestsSearchResult,
  [types.REQUEST_SIDEBAR]: state => state.requestSidebar,
  [types.APPROVERS_SEARCH_RESULT]: state => state.approversSearchResult,
  [types.APPROVER_SIDEBAR]: state => state.approverSidebar,
}
